import { CellValue } from 'react-table';

/**
 * Aggregates columns into a single performance value.
 */
export const aggregatePerformances = (
    leafValues: CellValue<number>[],
): number => leafValues?.[0] ?? 0;
